/**
 * LDR (Long-Distance Relationship) API
 *
 * Spec 115: Long-Distance Dynamic Tools
 */

import api from './client';

export interface PartnerInfo {
  userId: number | string;
  publicId: string;
  name: string;
  displayName: string | null;
  role: string;
  currentLocalTime: string;
  presenceStatus: string;
  isOnline: boolean;
  lastSeen: string | null;
  avatarUrl: string | null;
}

export const ldrAPI = {
  // Timezone
  getTimezone: () =>
    api.get('/users/me/timezone'),

  setTimezone: (timezone: string) =>
    api.put('/users/me/timezone', { timezone }),

  // Presence
  setPresence: (status: string) =>
    api.put('/users/me/presence', { status }),

  // Partner info
  getPartnerInfo: (orgId: string) =>
    api.get<{ success: boolean; data: PartnerInfo[] }>(`/ldr/${orgId}/partner-info`),

  // Request proof
  requestProof: (orgId: string, toUserId: number | string, message?: string) =>
    api.post(`/ldr/${orgId}/request-proof`, { toUserId, message }),

  // Thinking of you
  sendThinkingOfYou: (orgId: string, toUserId: number | string) =>
    api.post(`/ldr/${orgId}/thinking-of-you`, { toUserId }),
};
